export default class extends Controller {
  connect() {
    this.closeAllSlideOuts = this.closeAllSlideOuts.bind(this)
    App.Helpers.listenToCustomEvent(document, "overlay:click", this.closeAllSlideOuts)
  }

  disconnect() {
    App.Helpers.removeCustomEventListener(document, "overlay:click", this.closeAllSlideOuts)
  }

  closeSlideOut(event) {
    event && event.stopImmediatePropagation();
    App.SlideOut.close({ element: this.element })
  }

  closeAllSlideOuts(event) {
    event && event.stopImmediatePropagation();
    App.SlideOut.close({ element: this.element })
  }
}



// WEBPACK FOOTER //
// ./app/components/details/assets/javascript/details-slide-out-header-controller.js